import { render, staticRenderFns } from "./OrderWaybillList.vue?vue&type=template&id=6cb36081&"
import script from "./OrderWaybillList.vue?vue&type=script&lang=js&"
export * from "./OrderWaybillList.vue?vue&type=script&lang=js&"
import style0 from "./OrderWaybillList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports